import { render, staticRenderFns } from "./ClientSubsidiaryLedger.vue?vue&type=template&id=fc779896&scoped=true"
import script from "./ClientSubsidiaryLedger.vue?vue&type=script&lang=js"
export * from "./ClientSubsidiaryLedger.vue?vue&type=script&lang=js"
import style0 from "./ClientSubsidiaryLedger.vue?vue&type=style&index=0&id=fc779896&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc779896",
  null
  
)

export default component.exports